import { Icon, mixin } from "@hubrise/react-components"
import styled from "styled-components"

export const Summary = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

export const Line = styled.p``

export const ClickableIcon = styled(Icon)`
  ${mixin.clickable};
  padding: 0.25rem;
`
